import React from 'react';
import { readStates, states } from '@/constants/lifecycle';
import { datasetPermissions } from '../sharing/constants';
import { datasetPerms } from '../sharing/state/state';
import datasetStatus, { disableDatasetEdit, disableDatasetOnUpload } from '../status/helper';
import datasetNotificationSettings from '../settings/helper';
import customDatasetActions from '../links/helper';
import { editDataset } from '../actions';
import canManageDataset from '../sharing/helper';
import { resolveCatalogueTemplate } from '../catalogue/helper';
import { fetchDatasetLinks } from '../links/actions';
import { datasetIsEditing } from '../helper';
import { datasourceSupportsCategory } from '../datasource/helper';
import { datasourceFeatureCategories } from '../datasource/constants';
import { primaryDictionary } from '../dictionaries/state/state';

const DatasetActionsContainer = ({ children }) => (
  <>
    {children}
  </>
);

const accessControl = (
  role,
  perms,
  isEditing = false,
  disableEdit = true,
  disableOnUpload = true,
  readStatus = states.NONE,
) => {
  const { datasets } = role.permissions;
  return (
    {
      allowEdit: datasets.update && perms[datasetPermissions.UPDATE],
      allowDownload: datasets.download && readStatus === states.SUCCESS,
      allowManage: datasets.update && canManageDataset(perms),
      disableDownload: disableOnUpload || isEditing,
      disableEdit,
    });
};

const withoutItem = (role) => ({
  accessRequestAllowed: false,
  actions: [],
  actionsReadStatus: states.NONE,
  exists: false,
  cohortAllowed: false,
  notificationHistoryAllowed: false,
  url: '',
  workflowKey: '',
  ...accessControl(role, datasetPerms()),
  ...readStates,
  datasourceSupportsCohort: false,
});

const withItem = (dataset, template, role, datasourceFeatures, currentUser) => {
  const permissions = dataset.asViewer?.on ? dataset.asViewer.permissions : dataset.permissions;
  const disableEdit = disableDatasetEdit(dataset);
  const disableOnUpload = disableDatasetOnUpload(dataset);
  const dictionary = primaryDictionary(dataset, null);

  const datasetStatusProps = datasetStatus(role, dataset, dictionary);
  const datasourceSupportsCohort = datasourceSupportsCategory(datasourceFeatures, datasourceFeatureCategories.COHORT);

  return {
    ...customDatasetActions(dataset),
    code: dataset.code,
    dictionaryCode: dictionary ? dictionary.code : null,
    exists: true,
    isEditing: datasetIsEditing(dataset),
    name: dataset.catalogue.title,
    readStatus: dataset.readStatus,
    template,
    workflowKey: dataset.settings.workflow_key,
    ...accessControl(role, permissions, dataset.isEditing, disableEdit, disableOnUpload, dataset.readStatus),
    ...datasetNotificationSettings(dataset, currentUser.isGuest),
    ...datasetStatusProps,
    supportsCohort: datasetStatus.supportsCohort && datasourceSupportsCohort,
  };
};

export const mapStateToProps = ({
  auth: { role, currentUser },
  datasets: { datasets },
  catalogues: { templates },
  datasetDatasource: { features },
}, ownProps) => {
  const { dataset, template, datasourceFeatures } = resolveCatalogueTemplate(
    datasets,
    templates,
    ownProps,
    null,
    features,
  );
  return dataset ? withItem(dataset, template, role, datasourceFeatures, currentUser) : withoutItem(role);
};

export const mapDispatchToProps = {
  showEdit: editDataset,
  fetchActions: fetchDatasetLinks,
};

export default DatasetActionsContainer;
